import { render, staticRenderFns } from "./UserCheckBox.vue?vue&type=template&id=0442663a&"
import script from "./UserCheckBox.vue?vue&type=script&lang=js&"
export * from "./UserCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports